<template>
<div class='load-abris-block'>
    <div v-if='selectedLpo.sketch_path' class='abris-exists-text'>
        <span>Абрис уже загружен</span>
        <button class='preview-btn' @click='getImage'><i class='fa fa-eye'></i></button>
        <!-- <img ref='image'> -->
    </div>

    <ImagePreviewer ref='previewer' :url='objectURL'>
        <!-- <img ref='image'> -->
    </ImagePreviewer>

    <div>
        <div class='scale-block'>
            <span>Масштаб </span>
            <select v-model='scale' :disabled='!actLpoIsDraft'>
                <option :value='5000'>1 : 5 000</option>
                <option :value='10000'>1 : 10 000</option>
                <option :value='25000'>1 : 25 000</option>
                <option :value='50000'>1 : 50 000</option>
                <option :value='100000'>1 : 100 000</option>
                <option :value='200000'>1 : 200 000</option>
                <option :value='300000'>1 : 300 000</option>
            </select>
        </div>
        <label>
            <span class='custom-load-input'>{{selectedLpo.sketch_path ? 'Загрузить новое изображение' : 'Загрузить изображение абриса' }}</span>
            <input style='display: none;' ref='abris-file-input' type='file' accept="image" @input='onFileInput' :disabled='!actLpoIsDraft'>
        </label>
        <span v-if='selectedLpo.sketch_path && actLpoIsDraft' class='custom-load-input remove-btn' @click='removeFile'>Удалить изображение</span>
        <div class="abris-border-title">
            Укажите границы участка <br> (выдела/лесопатологического выдела) <br> для вычисления площади
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState,
    mapActions
} from 'vuex';

import ImagePreviewer from '@/lib/ImagePreviewer';

const ROOT_API = process.env.VUE_APP_ROOT_API;
const LOAD_ABRIS_LPO = ROOT_API + 'load_file/load_abris_lpo.php';
const REMOVE_ABRIS_LPO = ROOT_API + 'load_file/remove_abris_lpo.php';
const GET_ABRIS_LPO = ROOT_API + 'load_file/get_abris_lpo.php';

export default {
    name: 'LoadAbrisBlock',
    components: {
        ImagePreviewer
    },
    data: () => ({
        scale: 10000,
        objectURL: null,
    }),
    computed: {
        actLpoIsDraft() {
            return this.$store.getters['lpoData/actLpoIsDraft'];
        },

        ...mapState('selectedLpo', {
            selectedLpo: state => state.lpo
        })
    },
    methods: {
        onFileInput() {
            this.loadFile();
        },

        getImage() {
            const previewer = this.$refs['previewer'];
            // previewer.open();
            // return;

            const form = new FormData();
            form.append('lpo_id', this.selectedLpo.lpo_id);

            fetch(GET_ABRIS_LPO, {
                    credentials: 'include',
                    method: 'post',
                    body: form,
                })
                .then(res => res.blob())
                .then(myBlob => {

                    this.myBlob = myBlob;

                    previewer.open();

                    const myImage = this.$refs['image'];

                    this.objectURL = URL.createObjectURL(myBlob);
                    // myImage.src = objectURL;

                    // console.log(res);
                })
                .catch(err => {
                    throw err;
                });
        },

        removeFile() {
            const form = new FormData();
            form.append('lpo_id', this.selectedLpo.lpo_id);

            fetch(REMOVE_ABRIS_LPO, {
                    credentials: 'include',
                    method: 'post',
                    body: form,
                })
                .then(res => res.json())
                .then(res => {

                    if (res && res.code == 0) {
                        this.$toast.add({
                            severity: 'success',
                            detail: res.text,
                            life: 10000
                        });
                        this.updateLpo();
                    } else if (res && (res.code == 1)) {
                        this.$toast.add({
                            severity: 'warn',
                            detail: res.text,
                            life: 10000
                        });
                    } else {
                        this.$toast.add({
                            severity: 'warn',
                            detail: res.text,
                            life: 10000
                        });
                    }
                })
                .catch(err => {
                    throw err;
                });
        },

        loadFile() {

            const inputFile = this.$refs['abris-file-input'].files[0];

            if (!inputFile) {
                this.$toast.add({
                    severity: 'warn',
                    detail: 'Файл не выбран',
                    life: 10000
                });
                return;
            }

            const FILE_TYPE = 'image';
            const current_type = inputFile.type.split('/')[0];

            if (current_type != FILE_TYPE) {
                this.$toast.add({
                    severity: 'warn',
                    detail: 'Неверный тип файла',
                    life: 10000
                });
                return;
            }

            const MAX_SIZE = 10485760;
            if (inputFile.size > MAX_SIZE) {
                this.$toast.add({
                    severity: 'warn',
                    detail: 'Превышен максимальный размер файла (10 мб)',
                    life: 10000
                });
                return;
            }

            const form = new FormData();

            form.append('abris_file', inputFile);
            // form.append('abris_file_index', this.imgList.length);
            form.append('scale', this.scale);
            form.append('lpo_id', this.selectedLpo.lpo_id);
            // form.append('json_str', json_str);

            fetch(LOAD_ABRIS_LPO, {
                    credentials: 'include',
                    method: 'post',
                    body: form,
                })
                .then(res => res.json())
                .then(res => {

                    this.$refs['abris-file-input'].value = null;

                    if (res && res.code == 0) {
                        this.$toast.add({
                            severity: 'success',
                            detail: res.text,
                            life: 10000
                        });
                        this.updateLpo();
                    } else if (res && (res.code == 1 || res.code == 2 || res.code == 3)) {
                        this.$toast.add({
                            severity: 'warn',
                            detail: res.text,
                            life: 10000
                        });
                    } else {
                        this.$toast.add({
                            severity: 'warn',
                            detail: 'Ошибка',
                            life: 10000
                        });
                    }
                })
                .catch(err => {
                    throw err;
                });
        },

        ...mapActions('selectedLpo', [
            'updateLpo'
        ])
    }
};
</script>

<style scoped>
.abris-border-title {
    font-size: 16px;
    font-style: italic;
    font-weight: bold;
    margin-bottom: 10px;
}

.abris-exists-text {
    color: green;
}

.custom-load-input {
    border-radius: 5px;
    display: inline-block;
    padding: 4px 14px;
    background-color: black;
    color: white;
    cursor: pointer;
    margin: 10px 0 20px 0;
}

.scale-block {
    margin-top: 10px;
}

.remove-btn {
    margin-left: 10px;
}

.preview-btn {
    cursor: pointer;
    border: none;
    background-color: inherit;
}

.preview-btn:hover {
    color: green;
}
</style>
